import { Box, Button } from '@mui/material';
import React from 'react';
import { PrimaryButton } from './styles';

const CardImg = ({ img, title, subtitle, btn, onClick }) => {
  return (
    <Box style={{
        padding: "0",
        borderRadius: '12px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        width: "320px",
        backgroundColor: 'white',
        overflow: 'hidden',
        border: '1px solid #f0f0f0'
    }}>
      {/* Image Container */}
      <div style={{
        width: "100%",
        height: "200px",
        overflow: 'hidden',
        borderRadius: '12px 12px 0 0',
      }}>
          <img 
            src={img} 
            alt={title}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
            }}
          />
      </div>

      {/* Content Container */}
      <div style={{
        padding: '16px 20px 20px 20px'
      }}>
        {/* Title */}
        <h3 style={{
          margin: '0 0 8px 0',
          fontSize: '18px',
          fontWeight: '600',
          color: '#1a1a1a',
          lineHeight: '1.3'
        }}>
          {title}
        </h3>

        {/* Rating and Location */}
        {subtitle && (
          <div style={{ marginBottom: '12px' }}>
            {/* If subtitle is a string, style it similarly; otherwise render as-is to avoid invalid nesting */}
            {typeof subtitle === 'string' ? (
              <div style={{ margin: 0, fontSize: '14px', color: '#666', lineHeight: '1.4' }}>{subtitle}</div>
            ) : (
              <div style={{ fontSize: '14px', color: '#666', lineHeight: '1.4' }}>{subtitle}</div>
            )}
          </div>
        )}

        {/* Button */}
        {btn && (
          <Button 
            style={{
              ...PrimaryButton,
              width: '100%',
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: '500',
              textTransform: 'none',
              borderRadius: '8px'
            }}
            onClick={onClick}
          >
            {btn}
          </Button>
        )}
      </div>
    </Box>
  );
};

export default CardImg;